import { ContinueJourneySection } from "@/features/report-view"

import { ReportIds } from "@/features/today"

/**
 * "Continue your journey" cross-sell at the foot of the Soulmate report — reuses
 * the shared report-view slider, excluding the soulmate report itself.
 */
export function SoulmateContinueJourney() {
  return <ContinueJourneySection currentId={ReportIds.Soulmate} />
}
